import { createSelector } from 'reselect';

// Base selector to get the buyDelivery state
export const buyDeliverySelector = (state) => state.order.buyDelivery;

// Selector to get the loading state
export const selectIsLoadingQuote = createSelector(
  buyDeliverySelector,
  (state) => state.isLoadingQuote,
);
